import React from 'react';
import {get} from 'lodash';
import {gql} from 'apollo-boost';

import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorRespImg from '../../src/data-restructure/ui/resp-img';
import seoQuery from '../../src/graphql/queries/seo';
import client from '../../src/graphql/client';

import ClubPage from '../../src/containers/OwnersClubs/ClubPage';
  
const OwnersClub = (props) => {

  return (
    <div>
      <ClubPage 
        {...props}
      />
    </div>
  )
}

export async function getStaticPaths() {

  const GET_DYNAMIC_OWNERS_CLUBS_QUERY = gql`
    query GET_OWNERS_CLUBS_PATHS {
      ownersClubs {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_OWNERS_CLUBS_QUERY
  });

  let paths = [];
  
  const clubsOwners = get(result, 'data.ownersClubs.nodes', []);
  const domain = process.env.ASSIGNED_DOMAIN;

  clubsOwners.forEach(item => {
    const uri = get(item, 'uri', null);

    const assignedDomains = get(item, 'acf_domains.assignedDomains', []);
    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        id: uri
      }
    });
  });

  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;

  const GET_PAGE_CONTEXT = gql`
    query GET_OWNERS_CLUBS_PAGE {
      pageBy(uri: "owners-clubs?${countryCode.toLowerCase()}") {
        title
        uri
        seo {
          ${seoQuery}
        }
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner {
              fieldGroupName
              shbHeadingText
              shbBannerImage {
                ${respImgQuery}
              }
            }
          }
        }
      }
    }
  `

  const GET_OWNERS_CLUB = gql`
    query GET_OWNERSCLUB($uri: String){
      ownersClubBy(uri: $uri) {
        uri
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        acf_owners_club {
          ownClubActivitiesRep {
            ownClubActivity
          }
          ownClubCountry
          ownClubCtasRep {
            ownClubCtaLink {
              target
              title
              url
            }
          }
          ownClubDescription
          ownClubImage {
            ${respImgQuery}
          }
          ownStaffPositionsRep {
            ownStaffName
            ownStaffPosition
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  const pageProps = await client.query({
    query: GET_OWNERS_CLUB,
    variables: {
      uri: params.id
    }
  });

  if (contextProps) {
    const context = get(contextProps, 'data.pageBy', null);

    const hbData = get(context, 'acf_content_builder.contentBuilder', null);
    const heroBanner = hbData ? refactorHb(hbData[0], 'shb') : null;

    const seo = get(pageProps, 'data.ownersClubBy.seo', {});

    const title = get(pageProps, 'data.ownersClubBy.title', {});

    const description = get(pageProps, 'data.ownersClubBy.acf_owners_club.ownClubDescription', {});
    const image = get(pageProps, 'data.ownersClubBy.acf_owners_club.ownClubImage', {});
    const positions = get(pageProps, 'data.ownersClubBy.acf_owners_club.ownStaffPositionsRep', {});
    const activities = get(pageProps, 'data.ownersClubBy.acf_owners_club.ownClubActivitiesRep', {});
    const ctas = get(pageProps, 'data.ownersClubBy.acf_owners_club.ownClubCtasRep', {});
    const assignedDomains = get(pageProps, 'data.ownersClubBy.acf_domains.assignedDomains', []);
    const clubImage = image ? refactorRespImg(image, [{
      size: 'default',
      key: 'image_size_760x680'
    }]) : null;

    // breadcrumbs
    // Hardcoded here due to Owners Clubs CMS links are /owners-clubs-ccau and /owners-clubs-ccnz
    const breadcrumbs = {
      list: [
        {
          link: {
            title: 'Home',
            href: '/',
            target: '_self',
            assignedDomains
          },
          active: false
        },
        {
          link: {
            title: 'Owners Clubs',
            href: '/owners-clubs',
            target: '_self',
            assignedDomains
          },
          active: false
        },
        {
          link: {
            title,
            href: '/owners-clubs/' + pageProps.data.ownersClubBy.uri.replace('-ccau', '').replace('-ccnz', ''),
            target: '_self',
            assignedDomains
          },
          active: true
        }
      ]
    };

    const data = {
      meta: {
        title,
        seo,
        assignedDomains
      },
      breadcrumbs,
      heroBanner,
      title,
      description,
      clubImage,
      positions,
      activities,
      ctas
    }

    return {
      props: {
        ...data,
      }
    }
  } else { 
    return { props: {} }
  }
}

export default OwnersClub;